import { render, staticRenderFns } from "./NLPresult.vue?vue&type=template&id=04fc1ad2&scoped=true&"
import script from "./NLPresult.vue?vue&type=script&lang=js&"
export * from "./NLPresult.vue?vue&type=script&lang=js&"
import style0 from "./NLPresult.vue?vue&type=style&index=0&id=04fc1ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc1ad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
